import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { User, Mail, Phone, Calendar } from "lucide-react";

export default function DoctorPatients() {
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/patients");
        setPatients(data);
      } catch (e) {
        toast.error(formatErr(e?.response?.data?.detail) || e.message);
      }
    })();
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-emerald-700 mb-2">Patientèle</div>
        <h1 className="font-display text-3xl sm:text-4xl font-medium tracking-tight">Mes patients</h1>
        <p className="text-slate-500 mt-2">{patients.length} patient(s) suivi(s)</p>
      </div>

      {patients.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-slate-300 rounded-xl text-slate-500">
          Aucun patient pour le moment.
        </div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100">
          {patients.map((p) => (
            <div key={p.user_id} className="p-5 flex items-center justify-between gap-4" data-testid={`patient-${p.user_id}`}>
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 rounded-full bg-slate-100 flex items-center justify-center text-slate-700 font-semibold">
                  <User className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-display font-semibold">{p.name}</div>
                  <div className="text-xs text-slate-500 flex flex-wrap gap-3 mt-1">
                    <span className="flex items-center gap-1"><Mail className="h-3 w-3" /> {p.email}</span>
                    {p.phone && <span className="flex items-center gap-1"><Phone className="h-3 w-3" /> {p.phone}</span>}
                    {p.last_visit && <span className="flex items-center gap-1"><Calendar className="h-3 w-3" /> Dernière: {new Date(p.last_visit).toLocaleDateString("fr-FR")}</span>}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Link to={`/dashboard/prescriptions?patient_id=${p.user_id}`}>
                  <Button variant="outline" size="sm" data-testid={`rx-patient-${p.user_id}`}>Ordonnance</Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
